import MobileWebToMobileAppModal from './mobile-web-to-mobile-app-modal';

export default MobileWebToMobileAppModal;
